/**
 * 任务简报(V2 L2)—— 进对练之前先知道自己在演什么。
 *
 * 之前员工点进来直接就有人跟他说话,尤其是被派来练的人:不知道自己是谁、对方是谁、
 * 这次要练什么。
 *
 * **零后端零迁移**:要的字段(customerPersona / dimensions / difficulty)后端一直在下发,
 * 只是 H5 的 types 没声明。也**不做 LLM 摘要** —— 再调一次模型就是给最难受的接通时延
 * 又加两秒;人设第一句本来就是"这人是谁",够用。
 */

export interface BriefingSource {
  id: number;
  name: string;
  customerPersona?: string | null;
  dimensions?: { name?: string | null }[] | null;
  difficulty?: string | null;
}

export interface Briefing {
  /** 客户是谁(人设第一句)。 */
  who: string | null;
  /** 这次练什么(评估维度名)。 */
  goals: string[];
  /** 难度人话。 */
  level: string | null;
  /** 三样全空就别摆一张空卡片充数。 */
  hasContent: boolean;
}

const WHO_MAX = 45;
const LEVELS: Record<string, string> = {
  easy: "初级",
  medium: "中级",
  hard: "高级",
};
const SEEN_PREFIX = "coaching.briefed.";

/** 取人设第一句;没有句号就原样用;又长又没句号才截断。 */
function firstSentence(text: string): string {
  const line = text.trim().replace(/\s+/g, " ");
  for (const sep of ["。", "！", "!", "；", ";"]) {
    const idx = line.indexOf(sep);
    if (idx > 0 && idx + 1 <= WHO_MAX) return line.slice(0, idx + 1);
  }
  return line.length <= WHO_MAX ? line : line.slice(0, WHO_MAX) + "…";
}

export function briefingOf(scene: BriefingSource): Briefing {
  const persona = (scene.customerPersona ?? "").trim();
  const who = persona ? firstSentence(persona) : null;
  const goals = (scene.dimensions ?? [])
    .map((d) => (d?.name ?? "").trim())
    .filter(Boolean)
    .slice(0, 4);
  const level = scene.difficulty ? (LEVELS[scene.difficulty] ?? null) : null;
  return { who, goals, level, hasContent: Boolean(who) || goals.length > 0 };
}

export function hasSeenBriefing(scenarioId: number): boolean {
  try {
    return localStorage.getItem(SEEN_PREFIX + scenarioId) === "1";
  } catch {
    return false; // 隐私模式:当没看过,大不了每次都给简报
  }
}

export function markBriefingSeen(scenarioId: number): void {
  try {
    localStorage.setItem(SEEN_PREFIX + scenarioId, "1");
  } catch {
    // 存不下就每次都出简报,不值得为此报错
  }
}
